import { useEffect, useState } from "react";

const MOBILE_BREAKPOINT = 905;

export function useIsMobile() {
    const [isMobile, setIsMobile] = useState<boolean>(() => {
        if (typeof window === "undefined") {
            return false;
        }
        return window.innerWidth < MOBILE_BREAKPOINT;
    });

    useEffect(() => {
        if (typeof window === "undefined") return;

        const mql = window.matchMedia(
            `(max-width: ${MOBILE_BREAKPOINT - 1}px)`,
        );

        const onChange = (_: MediaQueryListEvent) => {
            setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
        };

        mql.addEventListener("change", onChange);

        return () => {
            mql.removeEventListener("change", onChange);
        };
    }, []);

    return isMobile;
}
